export default __webpack_public_path__ + "static/media/UserManagment_1.819540e8.png";